export enum BadgeSizeEnum {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum BadgeShapeEnum {
  Rounded = 'rounded',
  Fill = 'fill',
}

export enum BadgeColorEnum {
  Gray = 'gray',
  Primary = 'primary',
  Blue = 'blue',
}
